import React from "react";
import LoadingIcon from './LoadingIcon';
import PropTypes from 'prop-types';

const Loader = ({ height }) => {

  return (
    <div style={{ height: height }} className="modal-loader-wrapper">
		<LoadingIcon />
	</div>
  );
};

Loader.propTypes = {
  height: PropTypes.string,
};

export default Loader;